import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Dialog } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface ImportResultsModalProps {
  isOpen: boolean
  onClose: () => void
  results: {
    totalRows: number
    successfulImports: number
    skippedRows: number
    failedRows: number
    errors?: string[]
  } | null
}

export const ImportResultsModal = ({ isOpen, onClose, results }: ImportResultsModalProps) => {
  if (!results) return null

  const hasErrors = (results.errors?.length ?? 0) > 0 || results.failedRows > 0

  return (
    <F0Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={i18n.t('meetings.one_on_ones.import.results_modal.title')}
    >
      <Box flexDirection="column" gap="s16">
        <Box flexDirection="column" gap="s8">
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal size="200" weight="medium">
              {i18n.t('meetings.one_on_ones.import.results_modal.total_rows')}
            </Text.Normal>
            <Text.Normal size="200">{results.totalRows}</Text.Normal>
          </Box>

          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal size="200" weight="medium">
              {i18n.t('meetings.one_on_ones.import.results_modal.successful_imports')}
            </Text.Normal>
            <Text.Normal size="200">{results.successfulImports}</Text.Normal>
          </Box>

          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal size="200" weight="medium">
              {i18n.t('meetings.one_on_ones.import.results_modal.skipped_rows')}
            </Text.Normal>
            <Text.Normal size="200">{results.skippedRows}</Text.Normal>
          </Box>

          {results.failedRows > 0 && (
            <Box flexDirection="row" justifyContent="spaceBetween">
              <Text.Normal size="200" weight="medium">
                {i18n.t('meetings.one_on_ones.import.results_modal.failed_rows')}
              </Text.Normal>
              <Text.Normal size="200">{results.failedRows}</Text.Normal>
            </Box>
          )}
        </Box>

        {hasErrors && (results.errors?.length ?? 0) > 0 && (
          <Box flexDirection="column" gap="s8">
            <Text.Normal size="200" weight="medium">
              {i18n.t('meetings.one_on_ones.import.results_modal.errors')}
            </Text.Normal>
            <Box
              flexDirection="column"
              gap="s4"
              padding="s12"
              borderRadius={{ all: 'abs008' }}
              overflowY="auto"
              maxHeight="s200"
              background="radicalRed100"
            >
              {results.errors?.map((error, index) => (
                <Text.Normal key={index} size="100">
                  • {error}
                </Text.Normal>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </F0Dialog>
  )
}
